import React, {useEffect, useState} from 'react';
import { Avatar, Button, Dropdown, message, Upload } from 'antd';
import {
    CalendarOutlined, CameraOutlined,
    FlagOutlined,
    GlobalOutlined,
    HeartOutlined,
    IdcardOutlined,
    LogoutOutlined,
    MenuOutlined, PhoneOutlined, StarOutlined,
    TableOutlined,
    ToolOutlined,
    UserOutlined,
} from '@ant-design/icons';
import logo from '../../images/sila-skilla-white-logo.svg';
import {Link} from 'react-router-dom';
import {
    AUTOMATION,
    CLIENTS,
    default_report,
    GYM,
    INDEX,
    LOGOUT,
    POSTINGS, PROJECTS,
    SUBSCRIPTION,
    TASK,
    USER,
} from '../../routes';
import {useInstance} from "react-ioc";
import {Store} from "../../model/store/Store";
import {observer} from "mobx-react-lite";
import RoleFunctions from "../../config/roles";
import cls from './header.module.scss';
import TelegramOutlined from "../../vidgets/icon/TelegramOutlined";
import { useMutation } from '@apollo/client';
import { UPLOAD } from '../../graphql/upload';
import { UPDATE_CLIENT } from '../../graphql/client';
import { UPDATE_PARENT } from '../../graphql/parent';
import ImgCrop from 'antd-img-crop';
import { MUTATION_UPDATE_USER } from '../../graphql/user';
import ImageUrl from '../../helpers/ImageUrl';

function CrmHeader(props) {

    const {auth} = useInstance(Store);

    const [upload, uploadData] = useMutation(UPLOAD);
    const [update, updateData] = useMutation(MUTATION_UPDATE_USER);

    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,
    ]);

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    let firstName = '';
    let lastName = '';
    let color = null;

    if (auth.data !== null) {
        firstName = auth.data.firstName;
        lastName = auth.data.lastName;
        color = auth.data.color;

    }

    const items = [
        {
            key: INDEX,
            label: <Link to={INDEX}><CalendarOutlined/> Тренировки</Link>
        },
        {
            key: CLIENTS,
            label: <Link to={CLIENTS}><HeartOutlined/> Клиенты</Link>
        },
        {
            key: SUBSCRIPTION,
            label: <Link to={SUBSCRIPTION}><IdcardOutlined/> Абонементы</Link>
        },
        auth.role !== 'Trainer' && {
            key: 'TASK',
            label: <Link to={TASK}><FlagOutlined/> Задачи</Link>
        },
        auth.role !== 'Trainer' && {
            key: 'AUTOMATION',
            label: <Link to={AUTOMATION}><ToolOutlined/> Настройки задач</Link>
        },
        {
            key: USER,
            label: <Link to={USER}><UserOutlined/> Тренеры</Link>
        },
        {
            key: GYM,
            label: <Link to={GYM}><GlobalOutlined/> Залы</Link>
        },
        auth.role !== 'Trainer' && {
            key: 'report',
            label: <Link to={default_report()}><TableOutlined/> Отчеты</Link>
        },
        RoleFunctions.posting() && {
            key: POSTINGS,
            label: <Link to={POSTINGS}><TelegramOutlined/> Рассылки</Link>
        },
        RoleFunctions.project() && {
            key: PROJECTS,
            label: <Link to={PROJECTS}><StarOutlined/> Проекты</Link>
        },
    ]

    const userItems = [
        // {
        //     key: SETTINGS,
        //     label: <Link to={SETTINGS}><SettingOutlined/> Настройки</Link>
        // },
        {
            key: 'AVATAR',
            label: <ImgCrop aspect={1} cropShape={'round'} modalTitle={'Обрежьте фото'} modalOk={'Готово'} modalCancel={'Отмена'}>
                <Upload accept={'image/*'} maxCount={1} showUploadList={false}
                        customRequest={async ({ file }) => {
                            try {
                                await upload({
                                    variables: { file: file },
                                    onCompleted: async (res) => {
                                        await update({
                                            variables: {
                                                id: auth.id,
                                                data: {
                                                    avatar: res.upload.data.id,
                                                }
                                            },
                                            onCompleted: () => {
                                                auth.setRefresh(true);
                                            }
                                        })
                                    }
                                });
                            } catch (error) {
                                message.error(error.message);
                                console.error(error);
                                return false;
                            }
                        }}
                >
                    <span>
                        <CameraOutlined/> Обновить аватарку
                    </span>
                </Upload>
            </ImgCrop>,
        },
        {
            key: LOGOUT,
            label: <Link to={LOGOUT}><LogoutOutlined/> Выйти</Link>
        },
    ]

    // const userMenu = (
    //     <Menu>
    //         <Menu.Item key={10}>
    //             <Link to={SETTINGS}><SettingOutlined/> Настройки</Link>
    //         </Menu.Item>
    //         <Menu.Item key={11}>
    //             <Link to={LOGOUT}><LogoutOutlined/> Выйти</Link>
    //         </Menu.Item>
    //     </Menu>
    // );

    return (

        <header className={cls.header}>
            <div className={cls.content}>

                <div className={cls.left}>
                    <Dropdown menu={{items}} trigger="click">
                        <Button type={'text'} icon={<MenuOutlined/>} className={cls.menuButton}/>
                    </Dropdown>
                    <Link to={INDEX}>
                        <img src={logo} className={cls.logo} alt="logo"/>
                    </Link>
                </div>

                {props.children}

                <div className={cls.right}>
                    {windowSize[0] > 478 && <span className={cls.name}>{firstName} {lastName}</span>}
                    <Dropdown menu={{items: userItems}} trigger="click">
                        <Avatar
                            loading={uploadData.loading || updateData.loading}
                            size='small'
                            src={ImageUrl(auth.data?.avatar?.url)}
                                className={cls.avatar}
                                style={!auth.data?.avatar && {backgroundColor: color}}
                        >{firstName.charAt(0)}{lastName.charAt(0)}</Avatar>
                    </Dropdown>
                </div>
            </div>



        </header>
    );
}

export default observer(CrmHeader);
